// ** React Imports
import { useRef, useEffect, useLayoutEffect, useState } from 'react'
import GoogleMapReact from 'google-map-react'

// ** MUI Imports
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Third Party Components
import PerfectScrollbarComponent from 'react-perfect-scrollbar'

// ** Utils Imports
import { getInitials } from 'src/@core/utils/get-initials'
import CustomAvatar from 'src/@core/components/mui/avatar'

import Image from 'next/image'

import dayjs from 'dayjs'

import { Modal, Spin } from 'antd'

import byteConversion from 'src/utils/byteConversion'

import { useDispatch, useSelector } from 'react-redux'

import {
  loadingStatus,
  selectChat,
  switchUser,
  setPerViewImage,
  fetchChatsContacts,
  removeSelectedChat
} from 'src/store/apps/we-chat'
import NoData from 'src/components/NoData'

const PerfectScrollbar = styled(PerfectScrollbarComponent)(({ theme }) => ({
  padding: theme.spacing(5)
}))

const AnyReactComponent = ({ text }) => (
  <div className=' '>
    <div className='relative flex '>
      <div className=' absolute w-[180px] h-[40px] -mt-8 -ml-[70px] text-[13px] flex items-center  text-center text-[#4d5976] text-opacity-90 font-[500] bg-white  rounded-lg'>
        {text}
      </div>
      <div className='absolute flex items-center justify-center'>
        <Icon icon='material-symbols:location-on-rounded' width={50} height={50} className='text-[#FF5252]'></Icon>
      </div>
    </div>
  </div>
)

const MessagesLog = props => {
  // ** Props
  const { hidden, advanced } = props

  const data = useSelector(state => state.WeChat.selectedMessage)

  const [flag, setFlag] = useState(false)

  // ** Ref
  const chatArea = useRef(null)

  // ** Scroll to chat bottom
  const scrollToBottom = () => {
    if (chatArea.current) {
      if (chatArea.current._container.scrollTop == 0) {
        setTimeout(() => {
          chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER
        }, 2000)
      }

      if (hidden) {
        // @ts-ignore
        chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER

        // chatArea.current.scrollTop = Number.MAX_SAFE_INTEGER
      } else {
        // @ts-ignore
        chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER
      }
    }
  }

  // 记录首次加载
  const [isFirstLoad, setIsFirstLoad] = useState(true)

  useEffect(() => {
    if (data && data.selected && data.selected.length <= 50) {
      scrollToBottom()
      setIsFirstLoad(false)
    } else {
      if (chatArea.current) {
        if (hidden) {
          // @ts-ignore
          chatArea.current._container.scrollTop = 20
        } else {
          // @ts-ignore

          chatArea.current._container.scrollTop = 20
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // ** Renders user chat
  const renderChats = () => {
    if (data.selected.length == 0) {
      return (
        <div
          style={{
            background: '#F5F5F5',
            fontSize: '26px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#666',
            height: '100%'
          }}
        >
          <NoData />
        </div>
      )
    }

    return data.selected.map((item, index) => {
      const isSender = item.isFromMe

      const time = dayjs(Number(item.date + '000')).format('YY-MM-DD HH:mm')

      return (
        <>
          <Box
            key={item.PK + item.date + 1}
            className='row-item'
            sx={{
              display: 'flex',
              flexDirection: !item.isFromMe ? 'row' : 'row-reverse'
            }}
          >
            <Box
              className='chat-body'
              sx={{ maxWidth: ['calc(100% - 5.75rem)', '75%', '65%'], minWidth: '74px', position: 'relative' }}
              style={{
                maxWidth: item.messageType === 10000 ? '100%' : '',
                width: item.messageType === 10000 ? '100%' : ''
              }}
            >
              <Box key={index} sx={{ '&:not(:last-of-type)': { mb: 3.5 } }}>
                <div className='' style={{ display: 'flex' }}>
                  <Box
                    sx={{
                      borderRadius: 1,
                      p: theme => theme.spacing(0, 2),
                      ml: isSender ? 'auto' : undefined,
                      borderTopLeftRadius: !isSender ? 0 : undefined,
                      borderTopRightRadius: isSender ? 0 : undefined,
                      color: isSender ? 'black' : 'text.primary',
                      backgroundColor: isSender ? '#D1FAE5' : '#ffffff',
                      mb: 4.4,
                      mt: 2,
                      boxShadow: item.messageType === 10000 ? 'unset' : 1,
                      width: item.messageType === 10000 ? '100%' : 'fit-content 80%'
                    }}
                  >
                    {(() => {
                      try {
                        if (item.messageType === 1) {
                          let text = ''
                          let pic = ''
                          let name = ''

                          try {
                            if (store.members.length > 0) {
                              let str = item.text
                              let res = str.indexOf(':')
                              let content = str.substr(res + 1, str.length)

                              let userObj = store.members.find(row => row.wxid == str.substr(0, res))
                              text = `${content}`
                              name = `${userObj.name}`
                              pic = userObj.headImageUrl
                            } else {
                              text = item.text
                            }
                          } catch (error) {
                            text = item.text
                          }

                          return (
                            <div className='flex p-2 chat_box' style={{ flexDirection: 'column' }}>
                              {store.members.length > 0 ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: '4px',
                                    height: '24px',
                                    overflow: 'hidden'
                                  }}
                                >
                                  <Image
                                    src={pic}
                                    width='20'
                                    height='20'
                                    alt='img'
                                    style={{ borderRadius: '50%', width: '20px', height: '20px' }}
                                  />
                                  <span style={{ marginLeft: '4px', color: '#4E4E4E' }}> {name}</span>
                                </div>
                              ) : null}
                              <div>
                                <span
                                  className='chat_box font-semibold text-[0.8rem] text-black text-opacity-80 chat_box'
                                  style={{
                                    display: 'inline-block',
                                    wordBreak: 'break-all',
                                    maxWidth: '400px',
                                    overflow: 'hidden'
                                  }}
                                >
                                  {text}
                                </span>
                              </div>
                              <div
                                className='absolute  bottom-0 right-0'
                                style={{
                                  width: '120px',
                                  left: !item.isFromMe ? '0' : 'unset',
                                  right: item.isFromMe ? '0' : 'unset'
                                }}
                              >
                                <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                  <p className='text-[#9CA3AF] text-[0.6rem]'>{time}</p>
                                </h2>
                              </div>
                            </div>
                          )
                        } else if (item.messageType === 3) {
                          if (item.attachment.type == 'IMAGE') {
                            return (
                              <div className=' flex p-2 chat_box'>
                                <div>
                                  <span className='font-semibold text-[0.8rem] text-black text-opacity-80'>
                                    <Image
                                      src={'https://cos.spyx.com/' + item.attachment.url}
                                      alt='Picture of the author'
                                      width={150}
                                      height={150}
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => {
                                        dispatch(
                                          setPerViewImage({
                                            open: true,
                                            url: `https://cos.spyx.com/${item.attachment.url}`
                                          })
                                        )
                                      }}
                                    />
                                  </span>
                                </div>
                                <div className='absolute  bottom-0 right-0 '>
                                  <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                    <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                                  </h2>
                                </div>
                              </div>
                            )
                          } else {
                            return (
                              <div className=' flex p-2 chat_box'>
                                <div>
                                  <span className='font-semibold text-[0.8rem] text-black text-opacity-80'>
                                    <video
                                      controls={true}
                                      autoPlay={false}
                                      id='video'
                                      preload='none'
                                      loop={false}
                                      muted={false}
                                      poster={'https://cos.spyx.com/' + item.attachment.cover_url}
                                    >
                                      can not be used Video
                                      <source src={'https://cos.spyx.com/' + item.attachment.url} type='video/mp4' />
                                      <source src='movie.ogg' type='video/ogg' />
                                    </video>
                                  </span>
                                </div>
                                <div className='absolute  bottom-0 right-0 '>
                                  <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                    <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                                  </h2>
                                </div>
                              </div>
                            )
                          }
                        } else if (item.messageType === 34) {
                          return (
                            <>
                              <audio controls>
                                <source src={'https://cos.spyx.com/' + item.attachment.url} type='audio/mpeg' />
                                <embed
                                  height='50'
                                  width='100'
                                  src={'https://cos.spyx.com/' + item.attachment.url}
                                ></embed>
                              </audio>
                            </>
                          )
                        } else if (item.messageType === 42) {
                          return (
                            <div className=' flex p-2 chat_box'>
                              <div>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: '10px 0px',
                                    paddingRight: '20px'
                                  }}
                                >
                                  <Image
                                    style={{ width: '32px', height: '32px', borderRadius: '50%', marginRight: '10px' }}
                                    src={item.attachment.smallheadimgurl}
                                    width='20'
                                    height='20'
                                    alt='img'
                                  />
                                  <span
                                    className='chat_box font-semibold text-[0.8rem] text-black text-opacity-80 chat_box'
                                    style={{ display: 'inline-block', maxWidth: '400px', overflow: 'hidden' }}
                                  >
                                    {item.attachment.nickname}
                                  </span>
                                </div>
                                <div style={{ borderBottom: '1px' }}></div>
                              </div>
                              <div
                                className='absolute  bottom-0 right-0'
                                style={{
                                  width: '120px',
                                  left: !item.isFromMe ? '0' : 'unset',
                                  right: item.isFromMe ? '0' : 'unset'
                                }}
                              >
                                <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                  <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                                </h2>
                              </div>
                            </div>
                          )
                        } else if (item.messageType === 43 || item.messageType === 44 || item.messageType === 62) {
                          return (
                            <div className=' flex p-2 chat_box'>
                              <div>
                                <span className='font-semibold text-[0.8rem] text-black text-opacity-80 '>
                                  <video
                                    controls={true}
                                    autoPlay={false}
                                    id='video'
                                    preload='none'
                                    loop={false}
                                    muted={false}
                                    poster={'https://cos.spyx.com/' + item.attachment.cover_url}
                                  >
                                    can not be used Video
                                    <source src={'https://cos.spyx.com/' + item.attachment.url} type='video/mp4' />
                                    <source src='movie.ogg' type='video/ogg' />
                                  </video>
                                </span>
                              </div>
                              <div className='absolute  bottom-0 right-0 '>
                                <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                  <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                                </h2>
                              </div>
                            </div>
                          )
                        } else if (item.messageType === 47) {
                          return (
                            <div className=' flex p-2 chat_box'>
                              <div>
                                <span
                                  className='chat_box font-semibold text-[0.8rem] text-black text-opacity-80 chat_box'
                                  style={{ display: 'inline-block', maxWidth: '400px', overflow: 'hidden' }}
                                >
                                  {item.text}
                                </span>
                              </div>
                              <div
                                className='absolute  bottom-0 right-0'
                                style={{
                                  width: '120px',
                                  left: !item.isFromMe ? '0' : 'unset',
                                  right: item.isFromMe ? '0' : 'unset'
                                }}
                              >
                                <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                  <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                                </h2>
                              </div>
                            </div>
                          )
                        } else if (item.messageType === 48) {
                          return (
                            <div style={{ height: '270px', width: '270px' }}>
                              <GoogleMapReact
                                bootstrapURLKeys={{ key: process.env.NEXT_PUBLIC_GOOGLE_KEY }}
                                defaultCenter={{
                                  lat: Number(item.attachment.latitude),
                                  lng: Number(item.attachment.longitude)
                                }}
                                defaultZoom={15}
                              >
                                <AnyReactComponent
                                  lat={Number(item.attachment.latitude)}
                                  lng={Number(item.attachment.longitude)}
                                  text={item.attachment.label + item.attachment.poiname}
                                />
                              </GoogleMapReact>

                              <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                              </h2>
                            </div>
                          )
                        } else if (item.messageType === 50) {
                          return (
                            <div className=' flex p-2 chat_box'>
                              <div>
                                <span
                                  className='chat_box font-semibold text-[0.8rem] text-black text-opacity-80 chat_box'
                                  style={{ display: 'flex', maxWidth: '400px', overflow: 'hidden' }}
                                >
                                  {item.attachment.voip_msg}{' '}
                                  <span style={{ marginLeft: '4px' }}>
                                    {item.attachment.type === 'VOICE_CALL' ? (
                                      <Icon icon='material-symbols:call' width={18} height={18}></Icon>
                                    ) : (
                                      <Icon
                                        icon='material-symbols:auto-videocam-outline-sharp'
                                        width={18}
                                        height={18}
                                      ></Icon>
                                    )}
                                  </span>
                                </span>
                              </div>
                              <div
                                className='absolute  bottom-0 right-0'
                                style={{
                                  width: '120px',
                                  left: !item.isFromMe ? '0' : 'unset',
                                  right: item.isFromMe ? '0' : 'unset'
                                }}
                              >
                                <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                  <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                                </h2>
                              </div>
                            </div>
                          )
                        }
                      } catch (error) {
                        console.log(error)
                      }
                    })()}
                  </Box>
                </div>
              </Box>
            </Box>
          </Box>
          <Box className='row-item' key={item.PK + item.date + 2} style={{ color: 'red' }}>
            {item.messageType === 10000 || item.messageType === 10002 ? (
              <div className='chat_box' style={{ width: '100%' }}>
                <div style={{}}>
                  <p
                    style={{
                      display: 'inline-block',
                      overflow: 'hidden',
                      color: '#757C86',
                      textAlign: 'center',
                      width: '100%'
                    }}
                  >
                    {item.text}
                  </p>
                </div>
              </div>
            ) : null}
          </Box>
          <Box
            className='row-item'
            key={item.PK + item.date + 3}
            sx={{
              display: 'flex',
              flexDirection: !item.isFromMe ? 'row' : 'row-reverse',
              marginBottom: '10px'
            }}
          >
            {(() => {
              if (item.messageType === 49) {
                if (item.attachment && item.attachment.type === 'RED_PACKET') {
                  return (
                    <div
                      style={{
                        width: '250px',
                        height: '120px',
                        backgroundImage: 'linear-gradient(135deg,#D8AF7F,#EEAA59)',
                        borderRadius: '8px',
                        padding: '10px'
                      }}
                    >
                      <div
                        style={{
                          height: '84px',
                          borderBottom: '1px solid #E5B985',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Image src={item.attachment.iconurl} alt='packet' width='50' height='50' />
                        <span style={{ fontSize: '20px', color: '#fff', marginLeft: '10px' }}>
                          {item.attachment.sendertitle}
                        </span>
                      </div>
                      <p style={{ fontSize: '12px', color: '#fff', lineHeight: '2' }}>微信红包</p>
                    </div>
                  )
                } else if (item.attachment && item.attachment.type === 'TRANSFER') {
                  return (
                    <div
                      style={{
                        width: '250px',
                        height: '120px',
                        backgroundImage: 'linear-gradient(135deg,#D8AF7F,#EEAA59)',
                        borderRadius: '8px',
                        padding: '10px'
                      }}
                    >
                      <div
                        style={{
                          height: '84px',
                          borderBottom: '1px solid #E5B985',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Icon icon='bi:exclamation-circle' width={50} height={50} className='text-[#fff]'></Icon>
                        <span style={{ fontSize: '20px', color: '#fff', marginLeft: '10px' }}>
                          {item.attachment.feedesc}
                          {Number(item.attachment.invalidtime + '000') < new Date().getTime() ? (
                            <p style={{ fontSize: '14px' }}>已过期</p>
                          ) : null}
                        </span>
                      </div>
                      <p style={{ fontSize: '12px', color: '#fff', lineHeight: '2' }}>微信转账</p>
                    </div>
                  )
                } else if (item.attachment && item.attachment.type === 'FILE') {
                  return (
                    <div
                      style={{
                        width: '250px',
                        height: '80px',
                        background: '#fff',
                        borderRadius: '8px',
                        padding: '10px',
                        display: 'flex'
                      }}
                    >
                      <div style={{ width: '190px' }}>
                        <p style={{ fontSize: '18px' }}>{item.attachment.title}</p>
                        <p style={{ fontSize: '14px', color: '#C7C7C7' }}>{byteConversion(item.attachment.totallen)}</p>
                      </div>
                      <div style={{ width: '40px' }}>
                        <Icon icon='ci:file-pdf' width={50} height={50} className='text-[#E43E51]'></Icon>
                      </div>
                    </div>
                  )
                } else if (item.attachment && item.attachment.type === 'LINK') {
                  return (
                    <a
                      href={item.attachment.url}
                      style={{
                        width: '250px',
                        height: '120px',
                        background: '#fff',
                        borderRadius: '8px',
                        padding: '10px'
                      }}
                    >
                      <p
                        style={{
                          height: '50px',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: '2',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box'
                        }}
                      >
                        {item.attachment.title}
                      </p>
                      <p
                        style={{
                          height: '50px',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: '2',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box'
                        }}
                      >
                        {item.attachment.des}
                      </p>
                    </a>
                  )
                } else if (item.attachment && item.attachment.type === 'CARD') {
                  return (
                    <div
                      style={{
                        width: '250px',
                        height: '68px',
                        background: '#fff',
                        borderRadius: '8px',
                        padding: '10px'
                      }}
                    >
                      <p
                        style={{
                          height: '24px',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: '1',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          fontSize: '18px'
                        }}
                      >
                        {item.attachment.des}
                      </p>
                      <p
                        style={{
                          height: '24px',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: '1',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          fontSize: '16px'
                        }}
                      >
                        {item.attachment.brand_name}
                      </p>
                    </div>
                  )
                } else if (item.attachment && item.attachment.type === 'MUSIC') {
                  return (
                    <a
                      href={item.attachment.url}
                      style={{
                        width: '250px',
                        height: '80px',
                        background: '#fff',
                        borderRadius: '8px',
                        display: 'flex',
                        overflow: 'hidden'
                      }}
                    >
                      <Image
                        alt='qq music'
                        width='100'
                        height='100'
                        src={item.attachment.songalbumurl}
                        style={{ height: '100%', width: '90px' }}
                      />
                      <div
                        style={{
                          width: 'calc(250px - 90px)',
                          background: '#6F7886',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '0 10px'
                        }}
                      >
                        <div>
                          <p
                            style={{
                              color: '#fff',
                              WebkitBoxOrient: 'vertical',
                              WebkitLineClamp: '1',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box'
                            }}
                          >
                            {item.attachment.title}
                          </p>
                          <p
                            style={{
                              fontSize: '14px',
                              color: '#BBBBBB',
                              WebkitBoxOrient: 'vertical',
                              WebkitLineClamp: '1',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box'
                            }}
                          >
                            {item.attachment.des}
                          </p>
                        </div>
                        <div>
                          <Icon
                            icon='material-symbols:play-arrow-rounded'
                            width={30}
                            height={30}
                            className='text-[#fff]'
                          ></Icon>
                        </div>
                      </div>
                    </a>
                  )
                }
              }
            })()}
          </Box>
        </>
      )
    })
  }

  const store = useSelector(state => state.WeChat)
  const dispatch = useDispatch()

  const [scroll, setScroll] = useState(0)

  useEffect(() => {
    if (scroll >= 100) {
      if (store.selectedMessage.selected.length >= store.rightTotalCount) return
      dispatch(selectChat())
      setFlag(true)
      setTimeout(() => {
        setFlag(false)
      }, 1000)
    }
  }, [scroll])

  return (
    <>
      <Box
        sx={{
          borderBottomLeftRadius: '8px',
          borderBottomRightRadius: '8px'
        }}
        className={`bg-bgImg h-auto flex-1 ${advanced ? 'overflow-y-auto' : 'overflow-hidden'}`}
      >
        {hidden ? (
          <>
            {advanced ?
              <PerfectScrollbar
                ref={chatArea}
                options={{ wheelPropagation: false, suppressScrollX: true }}
                onScrollY={(e) => {
                  const progress = (e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0)

                  if (!isFirstLoad && progress >= 75) {
                    setScroll(progress)
                  }
                }}
              >
                {renderChats()}

                {flag ? (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Spin />
                  </div>
                ) : null}
              </PerfectScrollbar>
              :
              renderChats()
            }
          </>
        ) : (
          <>
            {advanced ?
              <PerfectScrollbar
                ref={chatArea}
                options={{ wheelPropagation: false }}
                onScrollY={(e) => {
                  const progress = (e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0)

                  if (!isFirstLoad && progress >= 75) {
                    setScroll(progress)
                  }
                }}
              >
                {renderChats()}

                {flag ? (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Spin />
                  </div>
                ) : null}
              </PerfectScrollbar>
              :
              renderChats()
            }
          </>
        )}
      </Box>

      <Modal
        title=''
        open={store.preViewImage.open}
        onCancel={() => {
          dispatch(
            setPerViewImage({
              open: false,
              url: ``
            })
          )
        }}
        width='540px'
        footer={[]}
        zIndex={1200}
      >
        <div style={{ padding: '14px' }}>
          <Image
            src={store.preViewImage.url}
            width={200}
            height={200}
            style={{ width: '460px', height: 'auto' }}
            alt='preview'
          ></Image>
        </div>
      </Modal>
    </>
  )
}

export default MessagesLog
